import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Input,
  Form,
  Dropdown,
  DatePicker,
  Divider,
  Select,
  Upload,
  Typography,
  InputNumber,
  Checkbox,
  Table,
  Radio,
  Modal,
  Popconfirm,
} from "antd";
import {
  DoubleRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileAddOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  LinkOutlined,
  PaperClipOutlined,
  EditFilled,
  PhoneOutlined,
  MailOutlined,
  InfoCircleOutlined,
  InfoCircleFilled,
} from "@ant-design/icons";
import dayjs from "dayjs";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addEstimateAPI,
  GetClientByIdApi,
  getEstimateByIdAPI,
  SendEmailForQuoteAcceptance,
  previewEstimateAPI,
  GetPartnerClientByIdApi,
  GetClientsByPartnerClientId,
} from "../ClientsApi";
import { useForm } from "antd/es/form/Form";
import QuoteTypesEnum from "features/Enums/QuoteTypesEnum";
import ServiceIntervalEnum from "features/Enums/ServiceIntervalEnum";
import { getProductsServicesAPI } from "features/ProductsandServices/ProductsandServicesAPI";
import {
  getSalesTaxAPI,
  getStatusAPI,
  GetLookupListApi,
  getQuoteTypeAPI,
  getServiceIntervalAPI,
  getEmployeeAPI,
  getCompanyListAPI,
  getcompaniesAPI,
  getEmployeesAPI,
  getAddressProvincesAPI,
  getAddressCountriesAPI,
  getAddressListAPI,
  GetPartnerSubClientsApi,
} from "CommonComponents/Lookup/LookupAPI";
import { render } from "@testing-library/react";
import { FormattedMessage, useIntl } from "react-intl";
import DiscountTypeEnum from "features/Enums/DiscountTypeEnum";
import StatusEnum from "features/Enums/StatusEnum";
import Address from "CommonComponents/Address";
import LookupTypeEnum from "features/Enums/LookupTypeEnum";
import ProductServiceTable from "./ProductServiceTable";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import FormType from "features/Enums/FormType";
import {
  getAttachments,
  uploadAttachment,
} from "CommonComponents/Attachments/AttachmentsAPI";
import QuoteAddress from "./QuoteAddress";
import SendEmailModal from "./SendEmailModal";
import {
  addFile,
  resetAttachments,
  setAttachments,
} from "CommonComponents/Attachments/AttachmentsSlice";
import AddressType from "features/Enums/AddressType";
import { GetLeadByIdApi } from "features/Leads/LeadsAPI";
import { resetPartnerSubClients } from "CommonComponents/Lookup/LookupSlice";
import RoleEnum from "features/Enums/RoleEnum";

function AddEstimate() {
  const { TextArea } = Input;
  const { Dragger } = Upload;
  const dateFormat = "DD/MM/YYYY";
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const location = useLocation();
  // const { projectId } = location?.state || {};
  const { cloneFrom } = location.state || {};
  const { leadId } = location?.state || {};
  const { Column } = Table;
  const intl = useIntl();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const quoteTypeId = Form.useWatch("quoteTypeId", form);
  const serviceIntervalId = Form.useWatch("serviceIntervalId", form);
  const { clientId, estimateId, partnerId, projectId } = useParams();
  const companyId = localStorage.getItem("CompanyId");
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "Quotations"
  )?.id;
  const attachmentsFromFiles = useSelector(
    (state) => state.Attachments.attachments
  );
  const fileTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadFiles"
  )?.id;
  const addFiles = useSelector((state) => state.Attachments.addFiles) || {};
  const newFilesCount = addFiles[formTypeId]?.length ?? 0;
  useEffect(() => {
    if (cloneFrom && !estimateId) {
      dispatch(getEstimateByIdAPI(cloneFrom));
    }
  }, [cloneFrom, estimateId, dispatch]);
  useEffect(() => {
    if (leadId && fileTypeId) {
      dispatch(getAttachments(leadId, fileTypeId));
    }

    const leadFilesGroup = attachmentsFromFiles?.[fileTypeId]?.[leadId];

    if (
      fileTypeId === FormType.LeadFiles?.id &&
      leadFilesGroup &&
      !attachmentsFromFiles?.[formTypeId]?.[estimateId] &&
      Array.isArray(leadFilesGroup.documents) &&
      leadFilesGroup.documents.length > 0 &&
      formTypeId
    ) {
      const documents = leadFilesGroup.documents.filter(
        (doc) => !doc.isThumbnail
      );

      const mapped = documents.map((doc, i) => ({
        uid: doc.guidFileName || `existing-${i}`,
        name: doc.originalFileName || `file-${i + 1}`,
        status: "done",
        url: `data:application/octet-stream;base64,${doc.base64Content}`,
        isExisting: true,
        id: doc.id,
      }));

      const quotationStructure = {
        [formTypeId]: {
          [estimateId]: {
            documents: leadFilesGroup.documents,
            formId: estimateId,
            formTypeId: formTypeId,
          },
        },
      };

      dispatch(setAttachments(quotationStructure));

      mapped.forEach((file, index) => {
        dispatch(
          addFile({
            fileName: file.name,
            base64: documents[index]?.base64Content,
            identifier: formTypeId,
            id: null,
          })
        );
      });

      setFileList(mapped);
    }
  }, [
    leadId,
    estimateId,
    fileTypeId,
    formTypeId,
    attachmentsFromFiles,
    dispatch,
  ]);

  const hostURL = process.env.REACT_APP_HOST_URL;
  const token = localStorage.getItem("token_bearer");
  //const [client, setClient] = useState(null);
  const clients = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state.clients.partnerClientById);
  const ClientsList = useSelector((state) => state.clients.clientsList);
  const partnerSubClients = useSelector(
    (state) => state.lookup.partnerSubClients
  );
  const addressList = useSelector((state) => state.lookup.addressList);
  const estimatesList = useSelector((state) => state.clients.estimatesList);
  const taxList = useSelector((state) => state.lookup.salesTaxList);
  const estimateDetails = useSelector((state) => state.clients.estimateById);
  const companyName = useSelector((state) => state.lookup.companies);
  const companyServices = useSelector(
    (state) => state.lookup.lookupData[LookupTypeEnum.CompanyService.id]
  );
  const leadById = useSelector((state) => state.leads.leadRecordById);
  const quoteTypes = useSelector((state) => state.lookup.quoteTypes);
  const intervals = useSelector((state) => state.lookup.intervals);
  const employeeList = useSelector((state) => state.lookup.employeesList);
  const estimateAttachments = useSelector(
    (state) => state.clients.estimateAttachments
  );
  const [depositType, setDepositType] = useState(true);
  const [selectedProductss, setSelectedProductss] = useState([
    {
      key: 1,
      id: 0,
      productId: null,
      name: "",
      description: "",
      quantity: 1,
      unitPrice: null,
      discount: 0,
      tax: null,
    },
  ]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [formInitialvalues, setFormInitialvalues] = useState();
  const [discount, setDiscount] = useState(0);
  const [selectedTax, setSelectedTax] = useState(null);
  const [isUploadRequired, setIsUploadRequired] = useState(false);
  const [discountType, setDiscountType] = useState(1);
  const [formattedSubTotal, setFormattedSubTotal] = useState("0.00");
  const [formattedGrandTotal, setFormattedGrandTotal] = useState("0.00");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [valueAddress, setValueAddress] = useState(1);
  const [estimateDate, setEstimateDate] = useState(dayjs());
  const [selectedTaxId, setSelectedTaxId] = useState(null);
  const [selectedTaxPercentage, setSelectedTaxPercentage] = useState(null);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [addressType, setAddressType] = useState("");
  //const [selectedAddressType, setSelectedAddressType] = useState(); // This holds 1, 2, or 3
  const [selectedBillingId, setSelectedBillingId] = useState(null);
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [depositAmount, setDepositAmount] = useState(0);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalBillOpen, setIsModalBillOpen] = useState(false);
  const [selectedPartnerClientId, setSelectedPartnerClientId] = useState(null);
  const [isPartnerScreen, setIsPartnerScreen] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [editingSalesPerson, setEditingSalesPerson] = useState(false);

  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded((prev) => !prev);
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const isQuillContentEmpty = (html) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent.trim() === "";
  };

  const onChange = (e) => {
    setValueAddress(e.target.value);
  };
  const handleViewPdf = async () => {
    try {
      const estimateInfo = await constructEstimateObject();
      if (estimateInfo?.EstimateItems?.length > 0) {
        await Promise.all([
          dispatch(previewEstimateAPI(estimateInfo)).then((res) => {
            const base64 = res?.value?.pdfBase64;
            const name = "Quote_Preview";

            if (base64) {
              const pdfWindow = window.open("", "_blank");
              const pdfContent = `data:application/pdf;base64,${base64}`;

              if (pdfWindow) {
                pdfWindow.document.write(`
                <html>
                  <head><title>${name}.pdf</title></head>
                  <body style="margin:0">
                    <iframe width="100%" height="100%" src="${pdfContent}" frameborder="0"></iframe>
                  </body>
                </html>
              `);
                pdfWindow.document.close();
              }
            } else {
              OpenNotificationWithIcon(
                "Error",
                "Common.Error",
                "",
                "AddEstimate.FailedToGeneratePDFPreview"
              );
            }
          }),
        ]);
      } else {
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AddEstimate.PleaseAddAlteast1Item"
        );
      }
    } catch (error) {
      console.error("Failed to preview PDF:", error);
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        error.message || "AddEstimate.UnableToPreviewPDF"
      );
    }
  };
  const showModal = async () => {
    try {
      await form.validateFields();
      if (
        !selectedProductss ||
        selectedProductss.filter((p) => p.productId).length === 0
      ) {
        OpenNotificationWithIcon(
          "warning",
          "Common.Warning",
          "",
          "Quote.Error.ProductServiceTable"
        );
        return;
      }
      setIsModalOpen(true);
    } catch (err) {}
  };
  const handleCancel = () => setIsModalOpen(false);

  const showModal1 = () => {
    setIsModalOpen1(true);
  };
  const handleCancel1 = () => setIsModalOpen1(false);
  const showBillModal = () => {
    setIsModalBillOpen(true);
  };
  const handleBillOk = () => {
    setIsModalBillOpen(false);
  };
  const handleBillCancel = () => {
    setIsModalBillOpen(false);
  };
  const openAddressModal = (type) => {
    setAddressType(type); // 'billing' or 'shipping'
    setIsAddressModalOpen(true);
  };

  const handleAddressCancel = () => {
    setIsAddressModalOpen(false);
    setAddressType("");
  };
  const selectedCompany = companyName?.items?.find(
    (company) => company?.id === parseInt(companyId)
  );

  const input = {
    pageNo: null,
    pageSize: null,
    searchQuery: "",
  };
  useEffect(() => {
    //dispatch(getProductsServicesAPI(input));
    dispatch(GetLookupListApi(LookupTypeEnum?.CompanyService?.id, input));
    dispatch(getQuoteTypeAPI());
    dispatch(getServiceIntervalAPI());
    dispatch(getEmployeesAPI());
    dispatch(getCompanyListAPI(input));
    dispatch(getStatusAPI());
    dispatch(getSalesTaxAPI());
    dispatch(getAddressProvincesAPI());
    dispatch(getAddressCountriesAPI());
    if (leadId) {
      dispatch(GetLeadByIdApi(leadId));
    }
  }, []);

  useEffect(() => {
    if (clientId && partnerId) {
      dispatch(GetClientByIdApi(clientId));
      dispatch(GetPartnerClientByIdApi(partnerId));
    } else if (clientId) {
      dispatch(GetClientByIdApi(clientId));
    } else if (partnerId) {
      dispatch(GetPartnerClientByIdApi(partnerId));
    }
    if (estimateId) {
      dispatch(getEstimateByIdAPI(estimateId));
    }
  }, [clientId, estimateId, partnerId]);

  useEffect(() => {
    if (clientSearchTerm != "") {
      dispatch(GetPartnerSubClientsApi(partnerId, clientSearchTerm));
    }
    dispatch(resetPartnerSubClients());
  }, [clientSearchTerm]);

  useEffect(() => {
    if (clientId && !partnerId && clients && !estimateDetails) {
      const billing = clients?.address?.find((a) => a.addressType === 2);
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      setBillingAddress(billing);
      setShippingAddress(shipping);
      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
      });
    } else if (
      !clientId &&
      partnerId &&
      partner &&
      !selectedPartnerClientId &&
      !estimateDetails
    ) {
      const billing = partner?.address?.find((a) => a.addressType === 2);
      setIsPartnerScreen(true);
      setBillingAddress(billing);
    } else if (
      clientId &&
      partnerId &&
      clients &&
      partner &&
      !estimateDetails
    ) {
      const billing = partner?.address?.find((a) => a.addressType === 2);
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      setBillingAddress(billing);
      setShippingAddress(shipping);
      setIsPartnerScreen(false);
      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
      });
    } else if (estimateDetails) {
      setIsPartnerScreen(false);
      const missingAddressIds = [];
      if (partner) {
        const billingAddress = partner?.address.find(
          (addr) => addr.id === estimateDetails?.billingAddressId
        );
        setBillingAddress(billingAddress);
        setSelectedPartnerClientId(estimateDetails?.clientId);
      } else {
        form.setFieldsValue({
          clientName: clients?.isResidential
            ? clients?.name
            : clients?.companyName,
        });
        const billingAddress = clients?.address.find(
          (addr) => addr.id === estimateDetails?.billingAddressId
        );

        const shippingAddress = clients?.address.find(
          (addr) => addr.id === estimateDetails?.addressId
        );
        if (billingAddress) {
          setBillingAddress(billingAddress);
        } else {
          missingAddressIds.push(estimateDetails.billingAddressId);
        }

        if (shippingAddress) {
          setShippingAddress(shippingAddress);
        } else {
          missingAddressIds.push(estimateDetails.addressId);
        }

        if (!billingAddress || !shippingAddress) {
          dispatch(getAddressListAPI(missingAddressIds));
        }
      }
    }
  }, [clients, partner, estimateDetails]);

  useEffect(() => {
    if (selectedPartnerClientId && estimateDetails) {
      const shipping = clients?.address?.find(
        (a) => a.id === estimateDetails?.addressId
      );
      if (shipping) {
        setShippingAddress(shipping);
      } else if (
        !shipping &&
        estimateDetails?.clientId != selectedPartnerClientId
      ) {
        const shipping = clients?.address?.find((a) => a.addressType === 1);

        setShippingAddress(shipping);
      } else {
        dispatch(getAddressListAPI([estimateDetails?.addressId]));
      }

      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
      });
    } else if (selectedPartnerClientId) {
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      setShippingAddress(shipping);
    }
  }, [clients]);

  useEffect(() => {
    if (selectedPartnerClientId) {
      dispatch(GetClientByIdApi(selectedPartnerClientId));
    }
  }, [selectedPartnerClientId]);

  useEffect(() => {
    if (billingAddress) {
      setSelectedBillingId(billingAddress?.id);
    }
  }, [billingAddress]);
  useEffect(() => {
    if (shippingAddress) {
      setSelectedShippingId(shippingAddress?.id);
    }
  }, [shippingAddress]);

  useEffect(() => {
    if (addressList) {
      const billing = addressList?.find(
        (addr) => addr.id === estimateDetails?.billingAddressId
      );
      const shipping = addressList?.find(
        (addr) => addr.id === estimateDetails?.addressId
      );

      if (billing) {
        setBillingAddress(billing);
      }

      if (shipping) {
        setShippingAddress(shipping);
      }
    }
  }, [addressList]);

  const renderAddress = (addr) => {
    if (!addr) return "";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage == "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage == "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;

    const parts = [
      addr.address1,
      addr.address2,
      addr.city,
      provinceName,
      countryName,
      addr.zip,
    ].filter(Boolean);

    return parts.join(", ");
  };

  useEffect(() => {
    if (selectedProductss.length == 0) {
      setDiscount(0);
      setDiscountType(1);
    }
  }, [selectedProductss]);

  const handleTaxChange = (value, option) => {
    if (!value) {
      setSelectedTaxId(null);
      setSelectedTaxPercentage(null);
      setSelectedTax(null);
      return;
    }
    const taxObject = taxList.find((tax) => tax?.id === value);
    if (taxObject) {
      setSelectedTaxId(taxObject?.id);
      setSelectedTaxPercentage(taxObject?.taxPercentage);
      setSelectedTax(taxObject?.taxPercentage);
    }
  };
  const getSubTotal = () => {
    if (estimateDetails && !selectedProductss.length) {
      return estimateDetails.totalCost || 0;
    }
    return selectedProductss.reduce((sum, product) => {
      const amount = Number(product.amount) || 0;
      return sum + amount;
    }, 0);
  };
  const getDiscountAmount = () => {
    const subTotal = getSubTotal();
    if (discountType) {
      return (subTotal * discount) / 100;
    } else {
      return Math.min(discount, subTotal);
    }
  };
  const getTaxAmount = () => {
    if (!selectedTaxPercentage) return 0;

    const subTotal = getSubTotal();
    return (subTotal * selectedTaxPercentage) / 100;
  };

  const getGrandTotal = () => {
    if (quoteTypeId === QuoteTypesEnum.Warranty?.id) {
      return 0;
    }
    if (estimateDetails && !selectedProductss.length && !selectedTax) {
      return estimateDetails.grandTotal || 0;
    }
    const subTotal = getSubTotal();
    const discountAmount = getDiscountAmount();
    const taxAmount = getTaxAmount();
    return subTotal - discountAmount + taxAmount;
  };
  useEffect(() => {
    const subTotal = getSubTotal();
    const grandTotal = getGrandTotal();

    setFormattedSubTotal(
      subTotal.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
    setFormattedGrandTotal(
      grandTotal.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }, [
    selectedProductss,
    selectedTaxPercentage,
    selectedTax,
    quoteTypeId,
    discount,
    discountType,
  ]);

  useEffect(() => {
    if (taxList?.length > 0 && selectedTaxId === null) {
      const defaultTax = taxList.find((tax) => tax.id === 6);
      if (defaultTax) {
        setSelectedTaxId(defaultTax.id);
        setSelectedTaxPercentage(defaultTax.taxPercentage);
        setSelectedTax(defaultTax.taxPercentage);
      }
    }
  }, [taxList]);

  const constructEstimateObject = async (emailData = null) => {
    try {
      const values = await form.validateFields();
      const grandTotal =
        quoteTypeId === QuoteTypesEnum.Warranty?.id ? 0 : getGrandTotal();
      const estimateDate = values.estimateDate
        ? dayjs(values.estimateDate).format("YYYY-MM-DD")
        : null;
      const expiryDate = values.expiryDate
        ? dayjs(values.expiryDate).format("YYYY-MM-DD")
        : null;
      const contractStartDate = values.contractStartDate
        ? dayjs(values.contractStartDate).format("YYYY-MM-DD")
        : null;
      const selectedMappedItems = selectedProductss
        .filter((product) => product.productId)
        .map((product) => ({
          Id: estimateId ? product.id : 0,
          EstimateId: estimateId ? estimateDetails?.id : 0,
          ProductServiceId: product.productId,
          Name: product.name,
          Description: product.description,
          Quanity: product.quantity,
          Rate: product.unitPrice,
          Discount: product.discount,
          Amount: product.amount,
          ClassId: null,
          IsActive: product.isActive ?? true, // default to true if not explicitly set
        }));
      const removedItems =
        estimateDetails?.estimateItems
          ?.filter(
            (dbItem) =>
              !selectedProductss.some((selItem) => selItem.id === dbItem.id)
          )
          .map((dbItem) => ({
            Id: dbItem.id,
            EstimateId: dbItem.estimateId,
            ProductServiceId: dbItem.productServiceId,
            Name: dbItem.productServiceName,
            Description: dbItem.description,
            Quanity: dbItem.quantity,
            Rate: dbItem.rate,
            Discount: dbItem.discount,
            Amount: dbItem.amount,
            ClassId: dbItem.classId,
            IsActive: false,
          })) ?? [];
      const estimateObject = {
        Id: estimateId ? estimateDetails?.id : 0,
        CompanyId: companyId,
        ClientId: clients?.id,
        AddressId: selectedShippingId,
        BillingAddressId: selectedBillingId,
        EstimateDate: estimateDate,
        ExpiryDate: expiryDate,
        TotalCost: parseFloat(formattedSubTotal.replace(/,/g, "")),
        TotalDiscount: discount,
        TotalTax: getTaxAmount(),
        TaxId: selectedTaxId,
        TaxPercentage: selectedTax || 0,
        GrandTotal: grandTotal.toFixed(2),
        Notes: values.notes,
        TermsAndConditions: values.termsAndConditions,
        EstimateStatusId: StatusEnum.Draft?.id,
        PONumber: values.ponumber,
        DiscountType: discountType,
        SalesPersonId: values.salesPersonId,
        Deposit: depositAmount,
        DepositType: depositType,
        companyServiceId: values.companyServiceId,
        QuoteTypeId: values.quoteTypeId,
        ServiceIntervalId: values.serviceIntervalId,
        ContractStartDate: contractStartDate,
        EndOccurances: values.endOccurances,
        IntervalInMonths: values.intervalInMonths,
        IntervalInYears: values.intervalInYears,
        LeadId: leadId && leadById ? leadById?.id : null,
        EstimateItems: [...selectedMappedItems, ...removedItems],
        BillingAddress: selectedBillingId ? null : billingAddress,
        shippingAddress: selectedShippingId ? null : shippingAddress,
        PartnerId: partnerId ? partnerId : null,
        ProjectId: projectId || null,
      };

      if (emailData) {
        var input = {
          estimate: estimateObject,
        };
        input.Email = {
          EstimateId: estimateId ? estimateDetails?.id : 0,
          EstimateStatusId: StatusEnum.Submitted?.id,
          To: values.email
            ? values.email.split(",").map((e) => e.trim())
            : [""],
          Cc: values.cc ? values.cc.split(",").map((e) => e.trim()) : [""],
          Subject: values.subject || "",
          Message: values.message || "",
          IncludedAttachment: values.includedAttachment ?? true,
        };
        return input;
      }

      return estimateObject;
    } catch (error) {
      console.log("Error in constructing estimate object:", error);
      throw error;
    }
  };
  const handleUpsertEstimate = async (checked) => {
    try {
      const estimateInfo = await constructEstimateObject();
      if (!estimateInfo || estimateInfo.EstimateItems?.length === 0) {
        OpenNotificationWithIcon(
          "warning",
          "Common.Warning",
          "",
          "Quote.Error.ProductServiceTable"
        );
        return;
      }
      dispatch(addEstimateAPI(estimateInfo, companyId)).then((res) => {
        if (res) {
          dispatch(uploadAttachment(res));
          setSelectedProductss((prev) => prev.filter((item) => item.productId));

          setIsUploadRequired(checked);
          const url =
            partnerId && clientId
              ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
              : clientId
              ? `/${companyId}/${clientId}/client_details`
              : `/${companyId}/${partnerId}/partner_client_details`;

          navigate(url);
          setSelectedPartnerClientId(null);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitQuoteAndSendEmail = async (emailData) => {
    try {
      await form.validateFields();
      const estimateInfo = await constructEstimateObject(emailData);
      if (!estimateInfo || estimateInfo.estimate?.EstimateItems?.length === 0) {
        OpenNotificationWithIcon(
          "warning",
          "Common.Warning",
          "",
          "Quote.Error.ProductServiceTable"
        );
        return;
      }
      const { estimate, ...inputWithoutEstimate } = estimateInfo;
      estimateInfo.estimate.EstimateStatusId = StatusEnum.Submitted?.id;
      dispatch(addEstimateAPI(estimateInfo?.estimate, companyId)).then(
        async (res) => {
          if (res) {
            await dispatch(uploadAttachment(res));
            inputWithoutEstimate.Email.EstimateId = res;
            dispatch(SendEmailForQuoteAcceptance(inputWithoutEstimate.Email));
            const url =
              partnerId && clientId
                ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/projects/${projectId}`
                : clientId
                ? `/${companyId}/${clientId}/client_details`
                : `/${companyId}/${partnerId}/partner_client_details`;

            navigate(url);
            setSelectedPartnerClientId(null);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const totalColumns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => {
        if (["1", "4", "5"].includes(record.key)) {
          return {
            children: text,
            props: { colSpan: 2 },
          };
        }
        return text;
      },
    },
    {
      title: "discountinput",
      dataIndex: "discountinput",
      key: "discountinput",
      width: 190,
      render: (text, record) => {
        if (["1", "4", "5"].includes(record.key)) {
          return { children: null, props: { colSpan: 0 } };
        }
        // if (record.key === "2") {
        //   return (
        //     <Space.Compact style={{ width: "100%" }}>
        //       <InputNumber
        //         style={{ width: "50%" }}
        //         value={discount}
        //         onChange={(value) => setDiscount(value)}
        //         min={0}
        //         max={discountType === 1 ? 100 : formattedSubTotal}
        //         precision={discountType === 1 ? 0 : 2}
        //       />
        //       <Select
        //         style={{ width: "50%" }}
        //         value={
        //           DiscountTypeEnum[
        //             Object.keys(DiscountTypeEnum).find(
        //               (key) => DiscountTypeEnum[key].id === discountType
        //             )
        //           ]?.value
        //         }
        //         onChange={(key) => setDiscountType(DiscountTypeEnum[key]?.id)}
        //       >
        //         {Object.entries(DiscountTypeEnum).map(([key, type]) => (
        //           <Select.Option key={type.id} value={key}>
        //             {type.value}
        //           </Select.Option>
        //         ))}
        //       </Select>
        //     </Space.Compact>
        //   );
        // }
        if (record.key === "3") {
          return (
            <Select
              value={selectedTaxId}
              onChange={handleTaxChange}
              className="w-100"
              allowClear
              placeholder="Select Tax"
            >
              {taxList?.map((tax) => (
                <Select.Option key={tax?.id} value={tax?.id}>
                  {tax.name} {tax.taxPercentage}%
                </Select.Option>
              ))}
            </Select>
          );
        }
        return text;
      },
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      align: "right",
      width: 130,
    },
  ];
  const data = [
    {
      key: "1",
      description: <FormattedMessage id="AddEstimate.SubTotal" />,
      value: `$${formattedSubTotal}`,
    },
    {
      key: "2",
      description: <FormattedMessage id="Quote.Discount" />,
      value: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            maxWidth: 320,
          }}
        >
          <Form.Item
            name="discount"
            style={{ margin: 0, flex: 1 }}
            rules={[
              {
                validator: (_, value) => {
                  const amount = value?.amount ?? 0;
                  const isPercent = value?.isPercent ?? false;
                  const subTotal = Number(getSubTotal());

                  if (isPercent && amount > 100) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "AddQuote.error.PercentTooHigh",
                      })
                    );
                  }
                  if (!isPercent && amount > subTotal) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "AddQuote.error.DiscountTooHigh",
                      })
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Group
              compact
              style={{ display: "flex", alignItems: "center" }}
            >
              <InputNumber
                style={{ width: 80 }}
                min={0}
                precision={2}
                value={discount}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                onChange={(val) => {
                  const amount = val || 0;
                  if (discountType === 1 && amount > 100) {
                    setDiscount(100);
                  } else {
                    setDiscount(amount);
                  }
                  form.setFieldValue("discount", {
                    amount: discountType === 1 && amount > 100 ? 100 : amount,
                    isPercent: discountType === 1,
                  });
                  form.validateFields(["discount"]);
                }}
                onBlur={() => {
                  form.validateFields(["discount"]);
                  form.setFieldValue("discount", {
                    amount: discount,
                    isPercent: discountType === 1,
                  });
                }}
                onKeyDown={(e) => {
                  if (
                    !/[\d.\b]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />

              <Select
                value={discountType}
                onChange={(val) => {
                  setDiscountType(val);
                  form.setFieldValue("discount", {
                    amount: discount,
                    isPercent: val === 1,
                  });
                  form.validateFields(["discount"]);
                }}
                style={{ width: 70, marginLeft: 8 }}
              >
                <Select.Option value={0}>$</Select.Option>
                <Select.Option value={1}>%</Select.Option>
              </Select>
            </Input.Group>
          </Form.Item>
          <div
            style={{
              minWidth: 70,
              textAlign: "right",
              marginLeft: 8,
              fontSize: 13,
            }}
          >
            {discountType === 1
              ? ` $${getDiscountAmount().toLocaleString("en-CA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : `$${getDiscountAmount().toLocaleString("en-CA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
          </div>
        </div>
      ),
    },
    {
      key: "3",
      description: <FormattedMessage id="AddEstimate.TotalTax" />,
      value: selectedTax ? `$${getTaxAmount().toFixed(2)} ` : "$0.00",
    },
    {
      key: "4",
      description: <FormattedMessage id="AddEstimate.GrandTotal" />,
      value: `$${formattedGrandTotal}`,
      className: "total-row",
    },
    {
      key: "5",
      description: (
        <div>
          <FormattedMessage id="Quote.DepositAmount" />
          <div style={{ fontSize: 12, color: "#faad14", marginTop: 2 }}>
            * Deposit amount can't be more than grand total
          </div>
        </div>
      ),
      value: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            maxWidth: 320,
          }}
        >
          <Form.Item
            style={{ margin: 0, flex: 1 }}
            name="deposit"
            rules={[
              {
                validator: (_, value) => {
                  const amount = value?.amount ?? 0;
                  const isPercent = value?.isPercent ?? false;

                  if (isPercent && amount > 100) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "AddQuote.error.DepositPercentTooHigh",
                      })
                    );
                  }
                  if (!isPercent && amount > getGrandTotal()) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "AddQuote.error.DepositTooHigh",
                      })
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Group
              compact
              style={{ display: "flex", alignItems: "center" }}
            >
              <InputNumber
                style={{ width: 80 }}
                min={0}
                precision={2}
                value={depositAmount}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                onChange={(val) => {
                  const amount = val || 0;
                  if (depositType && amount > 100) {
                    setDepositAmount(100);
                  } else {
                    setDepositAmount(amount);
                  }
                  form.setFieldValue("deposit", {
                    amount: depositType && amount > 100 ? 100 : amount,
                    isPercent: depositType,
                  });
                  form.validateFields(["deposit"]);
                }}
                onBlur={() => {
                  form.validateFields(["deposit"]);
                  form.setFieldValue("deposit", {
                    amount: depositAmount,
                    isPercent: depositType,
                  });
                }}
                onKeyDown={(e) => {
                  if (
                    !/[\d.\b]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />

              <Select
                value={depositType}
                onChange={(val) => {
                  setDepositType(val);
                  form.setFieldValue("deposit", {
                    amount: depositAmount,
                    isPercent: val,
                  });
                  form.validateFields(["deposit"]);
                }}
                style={{ width: 70, marginLeft: 8 }}
              >
                <Select.Option value={false}>$</Select.Option>
                <Select.Option value={true}>%</Select.Option>
              </Select>
            </Input.Group>
          </Form.Item>
          <div
            style={{
              minWidth: 70,
              textAlign: "right",
              marginLeft: 8,
              fontSize: 13,
            }}
          >
            {depositType
              ? `$${((getGrandTotal() * depositAmount) / 100).toLocaleString(
                  "en-CA",
                  { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )}`
              : `$${depositAmount.toLocaleString("en-CA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
          </div>
        </div>
      ),
    },
  ];
  useEffect(() => {
    if (estimateDetails) {
      const estimateDate = cloneFrom
        ? dayjs()
        : estimateDetails?.estimateDate
        ? dayjs(estimateDetails?.estimateDate, "YYYY-MM-DD")
        : null;
      const expiryDate = estimateDetails?.expiryDate
        ? dayjs(estimateDetails?.expiryDate, "YYYY-MM-DD")
        : null;
      const contractStartDate = estimateDetails?.contractStartDate
        ? dayjs(estimateDetails?.contractStartDate, "YYYY-MM-DD")
        : null;
      const addressIdExists = clients?.address?.some(
        (addr) => addr.addressId === estimateDetails?.addressId
      );
      const billingAddressIdExists = clients?.address?.some(
        (addr) => addr.addressId === estimateDetails?.billingAddressId
      );
      const taxObject = taxList?.find(
        (tax) => tax.id === estimateDetails?.taxId
      );
      if (taxObject) {
        setSelectedTaxId(taxObject?.id);
        setSelectedTaxPercentage(taxObject?.taxPercentage);
        setSelectedTax(taxObject?.taxPercentage);
      } else if (estimateDetails.taxPercentage) {
        setSelectedTaxId(estimateDetails?.taxId);
        setSelectedTaxPercentage(estimateDetails?.taxPercentage);
        setSelectedTax(estimateDetails?.taxPercentage);
      }
      if (estimateDetails.taxPercentage) {
        setSelectedTax(estimateDetails?.taxPercentage);
      }
      if (estimateDetails) {
        setDepositAmount(estimateDetails.deposit);
        setDepositType(estimateDetails.depositType || true);
        setDiscount(estimateDetails?.totalDiscount);
        setDiscountType(estimateDetails?.discountType || 1);
      }
      setFormattedSubTotal(
        estimateDetails.totalCost.toLocaleString("en-CA", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );

      setFormattedGrandTotal(
        estimateDetails.grandTotal.toLocaleString("en-CA", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );

      form.setFieldsValue({
        ...estimateDetails,
        estimateDate,
        expiryDate,
        contractStartDate,
        status: estimateDetails?.estimateStatusId,
        addressId: addressIdExists ? estimateDetails?.addressId : null,
        billingAddressId: billingAddressIdExists
          ? estimateDetails?.billingAddressId
          : null,
        deposit: estimateDetails.deposit,
        depositType: estimateDetails.depositType,
        taxPercentage: estimateDetails.taxPercentage,
        salesPersonId: estimateDetails?.salesPersonId,
      });

      setDiscount(estimateDetails?.totalDiscount);
      setDiscountType(estimateDetails?.discountType);
      setSelectedTax(estimateDetails?.totalTax);
      const filesAvailable = estimateAttachments?.length > 0;
      if (filesAvailable) {
        setIsUploadRequired(true);
      }
      if (estimateDetails?.estimateItems) {
        const initialProducts = estimateDetails?.estimateItems.map((item) => ({
          key: item.id,
          id: item.id,
          productServiceId: item.productServiceId,
          name: item.productServiceName,
          description: item.description,
          quantity: item.quantity,
          unitPrice: item.rate,
          discount: item.discount,
          amount: item.amount,
          isActive: item.isActive,
        }));
        setSelectedProducts(initialProducts);
      }
    }
  }, [estimateDetails, form]);
  useEffect(() => {
    if (selectedCompany?.termsAndConditions) {
      form.setFieldsValue({
        termsAndConditions: selectedCompany.termsAndConditions,
      });
    }
    if (estimateDate) {
      const expiry = estimateDate.clone().add(1, "month");
      form.setFieldsValue({ expiryDate: expiry });
    }
    if (leadId && leadById) {
      form.setFieldsValue({
        companyServiceId: leadById.companyServiceId,
      });
    }
    if (
      leadById &&
      employeeList?.some((emp) => emp.id === leadById.responsibleId)
    ) {
      form.setFieldsValue({
        salesPersonId: leadById.responsibleId,
      });
    }
  }, [selectedCompany, estimateDate, leadById, employeeList, form]);
  useEffect(() => {
    if (quoteTypeId === QuoteTypesEnum.Warranty?.id) {
      setFormattedGrandTotal("0.00");
    } else if (quoteTypeId === QuoteTypesEnum.PreventiveMaintenance?.id) {
      if (formattedGrandTotal === "0.00") {
        const subTotal = getSubTotal();
        const grandTotal =
          subTotal + (subTotal * (selectedTaxPercentage || 0)) / 100;
        setFormattedGrandTotal(
          grandTotal.toLocaleString("en-CA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      }
    }
  }, [quoteTypeId, getSubTotal]);

  const resetFormAndState = () => {
    form.resetFields();
    form.setFieldsValue({
      estimateDate: dayjs(),
      contractStartDate: dayjs(),
    });
    setEstimateDate(dayjs());
    setSelectedProducts([]);
    setDiscount(0);
    setDiscountType(1);
    setSelectedTax(null);
    setSelectedTaxId(null);
    setSelectedTaxPercentage(null);
    setFormattedSubTotal("0.00");
    setFormattedGrandTotal("0.00");
    setDepositAmount(0);
    setFileList([]);
    setIsUploadRequired(false);
  };
  useEffect(() => {
    if (!estimateId) {
      resetFormAndState();
    }
  }, [estimateId, form]);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const items = [
    {
      key: "1",
      label: (
        <Space direction="vertical">
          <div>
            <PhoneOutlined />
            &nbsp;&nbsp;
            {employeeList?.find(
              (emp) => emp?.id === form.getFieldValue("salesPersonId")
            )?.phone || "--"}
          </div>
          <div>
            <MailOutlined />
            &nbsp;&nbsp;
            {employeeList?.find(
              (emp) => emp?.id === form.getFieldValue("salesPersonId")
            )?.email || "--"}
          </div>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle" gutter={[16, 16]} justify="space-between">
              <Col>
                <h4>
                  {!estimateId ? (
                    <>
                      <FormattedMessage id="AddEstimate.AddEstimate" />
                      {/* {partner && `(${partner?.companyName})`} */}
                    </>
                  ) : (
                    <>
                      <FormattedMessage id="AddEstimate.EditEstimate" /> (
                      {estimateDetails?.estimateNo})
                    </>
                  )}
                </h4>
                <p className="mt-5px">
                  Create/Edit a quote to send to a prospective customer.
                </p>
              </Col>
              <Col className="text-right">
                {partner && (
                  <h4>
                    <FormattedMessage id="ClientDetails.PartnerOf" /> &nbsp;
                    {`${partner?.companyName}`}
                  </h4>
                )}
              </Col>
            </Row>
          </div>

          <Form
            form={form}
            name="basic"
            layout="vertical"
            initialValues={formInitialvalues}
            autoComplete="off"
            size="large"
            className="addestimate"
          >
            <Card bordered={false}>
              <Row gutter={[16, 4]}>
                <Col xs={24} sm={6} lg={5}>
                  {isPartnerScreen ? (
                    <Form.Item
                      label={<FormattedMessage id="AddEstimate.ClientName" />}
                      name="clientId"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "AddEstimate.error.PleaseSelectClient",
                          }),
                        },
                      ]}
                    >
                      <Select
                        placeholder={intl.formatMessage({
                          id: "AddEstimate.Placeholder.SelectClient",
                        })}
                        showSearch
                        allowClear
                        filterOption={false}
                        optionLabelProp="label"
                        notFoundContent={null}
                        onSearch={(value) => setClientSearchTerm(value)}
                        onChange={(value, option) => {
                          setSelectedPartnerClientId(value);
                          if (!value) {
                            dispatch(resetPartnerSubClients());
                          }
                        }}
                      >
                        {(partnerSubClients || [])
                          .filter(
                            (cl) =>
                              cl.isActive || cl.id == estimateDetails?.clientId
                          )
                          .map((cl) => (
                            <Select.Option
                              key={cl.id}
                              value={cl.id}
                              label={
                                cl.isResidential ? cl.nameEn : cl.companyName
                              }
                            >
                              {cl.isResidential ? cl.nameEn : cl.companyName} |{" "}
                              {cl.phone}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      label={<FormattedMessage id="AddEstimate.ClientName" />}
                      name="clientName"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "AddEstimate.error.PleaseEnterClientName",
                          }),
                        },
                        {
                          max: 50,
                          message: intl.formatMessage({
                            id: "AddEstimate.error.ClientNameCannotExceed50Characters",
                          }),
                        },
                      ]}
                    >
                      <Input
                        placeholder={intl.formatMessage({
                          id: "AddEstimate.placeholder.EnterClientName",
                        })}
                        maxLength={50}
                        disabled
                        value={
                          clients?.isResidential
                            ? clients?.name
                            : clients?.companyName
                        }
                      />
                    </Form.Item>
                  )}
                </Col>

                <Col xs={24} sm={6} lg={3}>
                  <Form.Item
                    label={<FormattedMessage id="AddEstimate.EstimateDate" />}
                    name="estimateDate"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "AddEstimate.error.PleaseSelectTheEstimateDate",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      disabledDate={(current) =>
                        current && current < dayjs().startOf("day")
                      }
                      placeholder={intl.formatMessage({
                        id: "AddEstimate.Placeholder.SelectEstimateDate",
                      })}
                      value={estimateDate}
                      onChange={(date) => setEstimateDate(date)}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} lg={3}>
                  <Form.Item
                    label={<FormattedMessage id="AddEstimate.ExpiryDate" />}
                    name="expiryDate"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "AddEstimate.error.PleaseSelectTheExpiryDate",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      disabledDate={(current) =>
                        current &&
                        current <
                          (estimateDate?.startOf("day") ||
                            dayjs().startOf("day"))
                      }
                      placeholder={intl.formatMessage({
                        id: "AddEstimate.Placeholder.SelectExpiryDate",
                      })}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} lg={3}>
                  <Form.Item
                    label={<FormattedMessage id="AddEstimate.PONumber" />}
                    name="ponumber"
                  >
                    <Input
                      placeholder={intl.formatMessage({
                        id: "AddEstimate.placeholder.EnterPO",
                      })}
                      maxLength={15}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} lg={4}>
                  <Form.Item
                    label={<FormattedMessage id="AddEstimate.BillingAddress" />}
                    name="billingAddressId"
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <EditFilled
                      className="edit-icon-quote"
                      onClick={() =>
                        openAddressModal(AddressType.BillingAddress.name)
                      }
                    />
                    <p>{renderAddress(billingAddress)}</p>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} lg={4}>
                  {shippingAddress ? (
                    <Form.Item
                      label={
                        <FormattedMessage id="AddEstimate.ShippingAddress" />
                      }
                      name="addressId"
                      //disabled={selectedPartnerClientId}
                      // rules={[
                      //   {
                      //     required: true,
                      //   },
                      // ]}
                    >
                      <EditFilled
                        className="edit-icon-quote"
                        onClick={() =>
                          openAddressModal(AddressType.CompanyAddress.name)
                        }
                      />
                      <p>{renderAddress(shippingAddress)}</p>
                    </Form.Item>
                  ) : null}
                </Col>
              </Row>
              <Row gutter={[16, 4]}>
                <Col xs={24} sm={6} lg={5}>
                  <Form.Item
                    label={<FormattedMessage id="Quote.SalesPerson" />}
                    name="salesPersonId"
                  >
                    {editingSalesPerson ||
                    !form.getFieldValue("salesPersonId") ? (
                      <Form.Item name="salesPersonId" noStyle>
                        <Select
                          showSearch
                          allowClear
                          placeholder={intl.formatMessage({
                            id: "Lead.PlaceHolder.SelectResponsiblePerson",
                          })}
                          optionFilterProp="children"
                          style={{ width: "100%" }}
                          onChange={(value) => {
                            form.setFieldsValue({ salesPersonId: value }); // ✅ update value manually
                            setEditingSalesPerson(false); // ✅ switch to view mode
                          }}
                        >
                          {employeeList
                            ?.filter(
                              (employee) =>
                                employee?.roleId === RoleEnum.Sales.id
                            )
                            .map((employee) => (
                              <Select.Option
                                key={employee?.id}
                                value={employee?.id}
                              >
                                {employee?.firstName} {employee?.lastName}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>
                    ) : (
                      <>
                        <EditFilled
                          className="edit-icon-quote"
                          onClick={() => setEditingSalesPerson(true)}
                        />
                        <div className="salesperson">
                          <p style={{ marginBottom: 0 }}>
                            {
                              employeeList?.find(
                                (emp) =>
                                  emp?.id ===
                                  form.getFieldValue("salesPersonId")
                              )?.firstName
                            }{" "}
                            {
                              employeeList?.find(
                                (emp) =>
                                  emp?.id ===
                                  form.getFieldValue("salesPersonId")
                              )?.lastName
                            }
                            &nbsp;&nbsp;&nbsp;
                            <Dropdown
                              menu={{ items }}
                              trigger={["click"]}
                              placement="bottom"
                            >
                              <InfoCircleFilled
                                style={{ color: "#1677ff", cursor: "pointer" }}
                              />
                            </Dropdown>
                          </p>
                        </div>
                      </>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} lg={3}>
                  <Form.Item
                    label={<FormattedMessage id="Quote.Services" />}
                    name="companyServiceId"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "Quote.Error.ServiceType",
                        }),
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      placeholder={intl.formatMessage({
                        id: "Quote.Placeholder.SelectService",
                      })}
                      style={{ width: "100%" }}
                    >
                      {companyServices
                        ?.filter((company) => company?.companyId == companyId)
                        ?.map((company) => (
                          <Select.Option key={company?.id} value={company?.id}>
                            {
                              company[
                                `name${
                                  selectedLanguage === "fr-FR" ? "Fr" : "En"
                                }`
                              ]
                            }
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} lg={4}>
                  <Form.Item
                    label={<FormattedMessage id="Quote.Type" />}
                    name="quoteTypeId"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "Quote.Error.QuoteType",
                        }),
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      placeholder={intl.formatMessage({
                        id: "Quote.Placeholder.SelectType",
                      })}
                      style={{ width: "100%" }}
                    >
                      {quoteTypes?.map((type) => (
                        <Select.Option key={type?.id} value={type?.id}>
                          {
                            type[
                              `name${
                                selectedLanguage === "fr-FR" ? "Fr" : "En"
                              }`
                            ]
                          }
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {quoteTypeId === QuoteTypesEnum.PreventiveMaintenance?.id && (
                  <Col xs={24} sm={6} lg={3}>
                    <Form.Item
                      label={<FormattedMessage id="Quote.SetInterval" />}
                      name="serviceIntervalId"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "Quote.Error.ServiceInterval",
                          }),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        placeholder={intl.formatMessage({
                          id: "Quote.Placeholder.SelectSetInterval",
                        })}
                      >
                        {intervals?.map((interval) => (
                          <Select.Option
                            key={interval?.id}
                            value={interval?.id}
                          >
                            {
                              interval[
                                `name${
                                  selectedLanguage === "fr-FR" ? "Fr" : "En"
                                }`
                              ]
                            }
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
                {quoteTypeId === QuoteTypesEnum.PreventiveMaintenance?.id &&
                  serviceIntervalId && (
                    <Col xs={24} sm={6} lg={3}>
                      <Form.Item
                        label={<FormattedMessage id="Quote.CreateQuote" />}
                        name="contractStartDate"
                        rules={[
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: "Quote.Error.ContractStartDate",
                            }),
                          },
                        ]}
                      >
                        <DatePicker
                          style={{ width: "100%" }}
                          disabledDate={(current) =>
                            current && current < dayjs().startOf("day")
                          }
                          placeholder={intl.formatMessage({
                            id: "Quote.Placeholder.SelectDate",
                          })}
                          format="YYYY-MM-DD"
                          defaultValue={dayjs()}
                          onChange={(date) => {
                            form.setFieldsValue({
                              contractStartDate: date,
                            });
                          }}
                          value={form.getFieldValue("contractStartDate")}
                        />
                      </Form.Item>
                    </Col>
                  )}
                {quoteTypeId == QuoteTypesEnum.PreventiveMaintenance?.id &&
                  serviceIntervalId == ServiceIntervalEnum.Monthly?.id && (
                    <Col xs={24} sm={6} lg={3}>
                      <Form.Item
                        label={<FormattedMessage id="Quote.IntervalInMonths" />}
                        name="intervalInMonths"
                      >
                        <Input
                          placeholder={intl.formatMessage({
                            id: "Quote.Error.IntervalInMonths",
                          })}
                          maxLength={2}
                        />
                      </Form.Item>
                    </Col>
                  )}
                {quoteTypeId == QuoteTypesEnum.PreventiveMaintenance?.id &&
                  serviceIntervalId == ServiceIntervalEnum.Yearly?.id && (
                    <Col xs={24} sm={6} lg={3}>
                      <Form.Item
                        label={<FormattedMessage id="Quote.IntervalInYears" />}
                        name="intervalInYears"
                      >
                        <Input
                          placeholder={intl.formatMessage({
                            id: "Quote.Error.IntervalInYears",
                          })}
                          maxLength={2}
                        />
                      </Form.Item>
                    </Col>
                  )}
                {quoteTypeId === QuoteTypesEnum.PreventiveMaintenance?.id && (
                  <Col xs={24} sm={6} lg={3}>
                    <Form.Item
                      label={
                        <FormattedMessage
                          id="Quote.EndOfOccurrences"
                          values={{
                            interval:
                              serviceIntervalId ===
                              ServiceIntervalEnum.Weekly?.id
                                ? "weeks"
                                : serviceIntervalId ===
                                  ServiceIntervalEnum.Monthly?.id
                                ? "months"
                                : "years",
                          }}
                        />
                      }
                      name="endOccurances"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "Quote.Error.EndOccurrences",
                          }),
                        },
                      ]}
                    >
                      <InputNumber
                        min={1}
                        style={{ width: "100%" }}
                        maxLength={2}
                        placeholder={`Enter number of ${
                          serviceIntervalId === ServiceIntervalEnum.Weekly?.id
                            ? "weeks"
                            : serviceIntervalId ===
                              ServiceIntervalEnum.Monthly?.id
                            ? "months"
                            : "years"
                        }`}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Card>

            <>
              <ProductServiceTable
                setFormattedSubTotal={setFormattedSubTotal}
                setFormattedGrandTotal={setFormattedGrandTotal}
                discount={discount}
                discountType={discountType}
                initialProducts={selectedProducts}
                selectedProductss={selectedProductss}
                setSelectedProductss={setSelectedProductss}
              />
            </>
            <Card bordered={false} className="mt-20">
              <Row gutter={[16, 16]} justify="end">
                <Col
                  xs={{ span: 24, order: 2 }}
                  sm={{ span: 24, order: 2 }}
                  md={{ span: 9, order: 1 }}
                  lg={{ span: 12, order: 1 }}
                >
                  <Row gutter={16}>
                    <Col xs={24} sm={24}>
                      <Form.Item
                        label={<FormattedMessage id="AddEstimate.Notes" />}
                        name="notes"
                      >
                        <TextArea rows={7} maxLength={500} />
                      </Form.Item>
                    </Col>
                    {/* <Col xs={24} sm={12}>
                      <Form.Item
                        label={
                          <FormattedMessage id="AddEstimate.TermsAndConditions" />
                        }
                        name="termsAndConditions"
                        initialValue={selectedCompany?.termsAndConditions}
                      >
                        <ReactQuill
                          theme="snow"
                          value={form.getFieldValue("termsAndConditions")}
                          onChange={(value) => {
                            form.setFieldsValue({
                              termsAndConditions: value,
                            });
                          }}
                          style={{ height: "120px" }}
                        />
                      </Form.Item>
                    </Col> */}
                  </Row>
                </Col>
                <Col
                  xs={{ span: 24, order: 1 }}
                  sm={{ span: 24, order: 1 }}
                  md={{ span: 15, order: 2 }}
                  lg={{ span: 12, order: 2 }}
                >
                  <Table
                    className="view-quotemail"
                    bordered
                    showHeader={false}
                    scroll={{
                      x: 300,
                    }}
                    columns={totalColumns}
                    dataSource={data}
                    pagination={false}
                    rowClassName={(record) =>
                      record.className === "total-row" ? "bold-text" : ""
                    }
                  />
                </Col>

                <Col xs={{ span: 24, order: 3 }} sm={{ span: 24, order: 3 }}>
                  <Typography.Text strong>
                    <FormattedMessage id="AddEstimate.TermsAndConditions" />
                  </Typography.Text>
                  <div className="quote-quill">
                    {selectedCompany?.termsAndConditions &&
                      !isQuillContentEmpty(
                        selectedCompany.termsAndConditions
                      ) && (
                        <>
                          <div
                            className={`clamped-content ${
                              expanded ? "expanded" : ""
                            }`}
                            dangerouslySetInnerHTML={{
                              __html: selectedCompany.termsAndConditions,
                            }}
                          />
                          <span
                            className="toggle-link"
                            onClick={toggleExpanded}
                          >
                            {expanded ? "Read less" : "Read more"}
                          </span>
                        </>
                      )}
                  </div>
                </Col>
              </Row>
              <Row gutter={[16, 4]} className="mt-20">
                <Col xs={24} sm={8} md={7}>
                  <Space>
                    <Button
                      color="primary"
                      variant="outlined"
                      size="medium"
                      onClick={handleViewPdf}
                    >
                      <EyeOutlined />
                      <FormattedMessage id="AddQuote.Preview" />
                    </Button>
                    <Button
                      color="primary"
                      variant="outlined"
                      size="medium"
                      onClick={showModal1}
                    >
                      <PaperClipOutlined />
                      {newFilesCount > 0 && ` ${newFilesCount}`}
                    </Button>
                  </Space>
                </Col>
                <Col
                  xs={24}
                  sm={16}
                  md={17}
                  lg={16}
                  xl={16}
                  className="text-right"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <Button
                    type="primary"
                    size="medium"
                    onClick={() => handleUpsertEstimate()}
                    disabled={
                      estimateDetails &&
                      !cloneFrom &&
                      estimateDetails.estimateStatusId !== 1
                    }
                  >
                    <CheckCircleOutlined />
                    {<FormattedMessage id="Quote.SaveAsDraft" />}
                  </Button>
                  <Button type="primary" size="medium" onClick={showModal}>
                    <CheckCircleOutlined />
                    {
                      <FormattedMessage id="AddEstimate.SaveEstimateAndSendEmail" />
                    }
                  </Button>
                  <Button
                    danger
                    variant="outlined"
                    size="medium"
                    onClick={() => {
                      resetFormAndState();
                      navigate(
                        partnerId && clientId
                          ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
                          : clientId
                          ? `/${companyId}/${clientId}/client_details`
                          : `/${companyId}/${partnerId}/partner_client_details`
                      );
                    }}
                  >
                    <CloseCircleOutlined />
                    {<FormattedMessage id="AddEstimate.Cancel" />}
                  </Button>
                </Col>
              </Row>
            </Card>
          </Form>
          {isAddressModalOpen && (
            <QuoteAddress
              billingAddress={billingAddress}
              shippingAddress={shippingAddress}
              setBillingAddress={setBillingAddress}
              setShippingAddress={setShippingAddress}
              onCancel={() => setIsAddressModalOpen(false)}
              addressType={addressType}
            />
          )}
          <Modal
            title={<FormattedMessage id="Quote.UploadAttachments" />}
            width={800}
            open={isModalOpen1}
            onCancel={handleCancel1}
            footer={[
              <Button key="ok" type="primary" onClick={handleCancel1}>
                Ok
              </Button>,
            ]}
          >
            <Form form={form} size="large" layout="vertical">
              <Form.Item
                label={<FormattedMessage id="AddEstimate.Attachments" />}
                //name="Attachments"
                valuePropName="fileList"
                getValueFromEvent={(e) =>
                  Array.isArray(e) ? e : e && e.fileList
                }
              >
                <AttachmentComponent
                  identifier={formTypeId}
                  currentId={estimateId}
                  getattachments={true}
                />
              </Form.Item>
            </Form>
          </Modal>
          <SendEmailModal
            type="quote"
            isOpen={isModalOpen}
            onCancel={handleCancel}
            onSend={handleSubmitQuoteAndSendEmail}
            form={form}
            estimateId={estimateId}
            attachmentsFromFiles={attachmentsFromFiles}
            estimateDetails={estimateDetails}
          />
        </div>
      </div>
    </>
  );
}

export default AddEstimate;
